import { Directive, Input, ElementRef, OnChanges, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[appCountUpMoney]',
  standalone: true
})
export class CountUpMoneyDirective implements OnChanges {
  private el = inject(ElementRef);

  @Input('appCountUpMoney') targetValue = 0;
  @Input() duration = 1000; 

  private currentDisplayValue = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['targetValue']) {
      this.animate();
    }
  }

  private animate() {
    const start = this.currentDisplayValue;
    const end = this.targetValue;
    const startTime = performance.now();

    this.el.nativeElement.classList.add('counting');

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const currentCount = Math.floor(easeProgress * (end - start) + start);
      
      this.currentDisplayValue = currentCount;
      
      // Formatting as currency manually since it's direct DOM manipulation
      this.el.nativeElement.innerText = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(currentCount);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        this.el.nativeElement.classList.remove('counting');
      }
    };

    window.requestAnimationFrame(step);
  }
}